import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import DataState from '../../components/DataState';
import EventRegistration from './EventRegistration';
import { useCollections } from '../../lib/api/collections';
import { useSeo } from '../../lib/seo';
import { eventImages } from '../../data/images';

const eventRowLabels = ['Date', 'Venue', 'Type', 'Photos', 'Hosted by', 'Batch / Year'];

const EventDetailsMain = () => {
  const { slug } = useParams();
  const content = useCollections('events');
  const found = content.events && content.events.find((e) => e.id === slug);
  useSeo(found ? { title: found.seoTitle || `${found.title} | SANASA Campus`, description: found.seoDescription || found.summary } : null);
  if (content.loading || content.error) return <DataState state={content} />;
  const event = content.events.find((e) => e.id === slug);
  const detail = event && event.detail;
  if (!event || !detail) return <Navigate to="/events" replace />;
  const pictures = eventImages(event);

  return (
    <main>
      <Breadcrumb title="Event Details" subTitle="Events" />

      <div className="it-event-details-area pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-xl-9 col-lg-8">
              <div className="it-evn-details-wrap">
                <div className="it-evn-details-thumb mb-35">
                  <img src={pictures.wide} alt="" />
                </div>
                <h4 className="it-evn-details-title">{event.title}</h4>
                <div className="postbox__meta">
                  <span>
                    <i className="fa-light fa-tag"></i>
                    {detail.meta[0]}
                  </span>
                  <span>
                    <i className="fa-light fa-calendar-days"></i>
                    {detail.meta[1]}
                  </span>
                  <span>
                    <i className="fa-light fa-location-dot"></i>
                    {detail.meta[2]}
                  </span>
                </div>
                <div className="it-evn-details-text mb-40">
                  <p>{detail.intro}</p>
                </div>
                <div className="it-evn-details-text">
                  <h6 className="it-evn-details-title-sm pb-10">
                    {detail.heading}
                  </h6>
                  <p>{detail.body}</p>
                </div>
                {event.registrationEnabled && <EventRegistration slug={event.id} />}
              </div>
            </div>
            <div className="col-xl-3 col-lg-4">
              <div className="it-evn-sidebar-box it-course-sidebar-box">
                <div className="it-evn-sidebar-thumb mb-30">
                  <img src={pictures.side} alt="" />
                </div>
                <div className="it-course-sidebar-rate-box pb-20">
                  <div className="it-course-sidebar-rate d-flex justify-content-between align-items-center">
                    <span>Held on</span>
                    <span className="rate">{event.year}</span>
                  </div>
                  <i>{event.type}</i>
                </div>
                <Link
                  className="ed-btn-square radius purple-4 w-100 text-center mb-20"
                  to="/events"
                >
                  <span>All Events</span>
                </Link>
                <div className="it-evn-sidebar-list">
                  <ul>
                    {eventRowLabels.map((label, i) => (
                      <li key={label}>
                        <span>{label}</span>
                        <span>{detail.rows[i]}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
export default EventDetailsMain;
